import { render, staticRenderFns } from "./AuthorItem.vue?vue&type=template&id=314d32c8&scoped=true"
import script from "./AuthorItem.vue?vue&type=script&lang=js"
export * from "./AuthorItem.vue?vue&type=script&lang=js"
import style0 from "./AuthorItem.vue?vue&type=style&index=0&id=314d32c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314d32c8",
  null
  
)

export default component.exports